// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC9cQFN5NykskKhdoTin78iIF5rUpStgOU",
  authDomain: "mokshiq-fbd4a.firebaseapp.com",
  projectId: "mokshiq-fbd4a",
  storageBucket: "mokshiq-fbd4a.firebasestorage.app",
  messagingSenderId: "1017024057708",
  appId: "1:1017024057708:web:17291459409a2cf1f92349",
  measurementId: "G-GCTL8PFT5M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);
export const requestNotificationPermission = async () => {
    try {
      const token = await getToken(messaging, { vapidKey: "BJOMEFvmBPwgWiMZxYZy9alV9bQKOxm-wqbk9oWgtVNTbFU8lSsIlmR3bmLpT13HExQ7DGGL145JlMtm3zHVkRc" });
      console.log("FCM Token:", token);
      localStorage.setItem("fcmToken", token);
      return token;
    } catch (err) {
      console.error("Permission denied:", err);
      return null;
    }
  };
  
  export const onMessageListener = () =>
    new Promise((resolve) => {
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    });